import React from 'react';
import { Loading } from '@match/react-component-library';
import { Redirect } from 'react-router-dom';
import api from 'utils/api-services';
import { PageLayout } from '../../layouts';

interface UserState {
  isAuthenticated: boolean;
  isEligible: boolean;
  isLoading: boolean;
}

class PreLandingPage extends React.Component<{}, UserState> {
  state = {
    isAuthenticated: false,
    isEligible: false,
    isLoading: true
  }

  componentDidMount() {
    this.fetchUser();
  }

  fetchUser = async () => {
    const res = await api.getUserEligibility();
    console.log(res);
    if (res instanceof Error) {
      this.setState({
        isAuthenticated: false,
        isLoading: false
      });
    } else if (!res.isAuthenticated) {
      this.setState({
        isAuthenticated: false,
        isLoading: false
      });
    } else if (res.isEligible) {
      this.setState({
        isAuthenticated: true,
        isEligible: true,
        isLoading: false
      })
    } else {
      this.setState({
        isAuthenticated: true,
        isEligible: false,
        isLoading: false
      })
    }

  }

  render() {
    const { isAuthenticated, isEligible, isLoading } = this.state;

    return (
      <PageLayout dark>
        {isLoading && <Loading size='medium' />}
        {!isLoading && !isAuthenticated && (
          <Redirect to={`${process.env.PUBLIC_URL}/landing`} />
        )}
        {!isLoading && isAuthenticated && !isEligible && (
          <Redirect to={`${process.env.PUBLIC_URL}/ineligible`} />
        )}
        {!isLoading && isAuthenticated && isEligible && (
          <Redirect to={`${process.env.PUBLIC_URL}/redeem`} />
        )}
      </PageLayout>
    )
  }
}

export default PreLandingPage;
